// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import './assets/icon/iconfont.css'
import VueWechatTitle from 'vue-wechat-title';
import BASE_API from './utils/api'

Vue.use(VueWechatTitle)
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.$apiBase = BASE_API
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js